const CustomerColumn = ({
    row,
    value,
    column: {
        rows,
    },
}) => {
    const resolvedRow = row ?? rows.find((row) => row.EntityId === value);
    return resolvedRow.CustomerName ?? '-';
};

export default CustomerColumn;
